import { useTranslation } from 'react-i18next'

import { BrandMark } from '@/components/BrandMark/BrandMark'

import styles from './LandingFooter.module.scss'

const LINKS = [
  { key: 'agreement', href: 'https://intch.org/legal/agreement' },
  { key: 'privacy', href: 'https://intch.org/legal/privacy' },
  { key: 'blog', href: 'https://intch.org/blog' },
  { key: 'contacts', href: 'https://intch.org/contact-us' },
  { key: 'reviews', href: 'https://intch.org/reviews' },
] as const

/** The parent site's footer: two rows so the link list can wrap without pushing the mark
 * off its baseline. */
export const LandingFooter = () => {
  const { t } = useTranslation()

  return (
    <footer className={styles.root}>
      <div className={styles.row}>
        <div className={styles.logo}>
          <BrandMark nameClassName={styles.productName} />
        </div>
        <nav className={styles.links}>
          {LINKS.map((link) => (
            <a key={link.key} href={link.href} target="_blank" rel="noopener">
              {t(`landing.footer.${link.key}`)}
            </a>
          ))}
        </nav>
      </div>
      <div className={styles.bottom}>
        <span>Intch 2026</span>
        <a href="https://intch.org" target="_blank" rel="noopener">
          intch.org
        </a>
      </div>
    </footer>
  )
}
